import React, { Component } from 'react';
class Modal extends Component {

    constructor(props) {
        super(props);

        this.outerStyle = {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "auto",
            zIndex: 1
        };

        this.style = {
            modal: {
                position: "relative",
                width: 1276,
                boxSizing: "border-box",
                backgroundColor: "#fff",
                margin: "40px auto",
                borderRadius: 3,
                zIndex: 2,
                textAlign: "left",
                boxShadow: "0 20px 30px rgba(0, 0, 0, 0.2)",
                height: 718,
                ...this.props.style.modal
            },
            overlay: {
                position: "fixed",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                ...this.props.style.overlay
            }
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const img = document.getElementById('image-view')
        if (nextProps.isModalOpen) {
            document.body.classList.add("modal-open")
            setTimeout(() => img.classList.add("image-view"), 0)
        } else {
            document.body.classList.remove("modal-open")
            img.classList.remove("image-view")
        }
    }

    render() {
        return (
            <div
                style={{
                    ...this.outerStyle,
                    display: this.props.isModalOpen ? "block" : "none"
                }}
            >
                <div style={this.style.overlay} onClick={this.props.closeModal} />
                <div onClick={this.props.closeModal} />
                <div style={this.style.modal}>{this.props.children}</div>
            </div>
        );
    }
}

export default Modal;